import { ReactNode } from "react";
import {
  warningColor,
  whiteColor,
} from "vendor/material-dashboard-pro-react-v1/assets/jss/material-dashboard-pro-react.jsx";

type Props = {
  text?: string;
  dataQa?: string;
  textColor?: string;
  children?: ReactNode;
};

function InlinePageWarning({
  text,
  dataQa = "warning",
  textColor = whiteColor,
  children,
}: Props) {
  if (!text) {
    return null;
  }
  return (
    <div
      data-qa={dataQa}
      style={{
        backgroundColor: warningColor[1],
        padding: 10,
        color: textColor,
      }}>
      ⚠ {text}
      {children}
    </div>
  );
}

export default InlinePageWarning;
